module.exports = __webpack_public_path__ + "static/media/historyIcon.ce77f1ca.svg";